import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app.module';

platformBrowserDynamic()
  .bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/app/main.ts